export default "__VITE_ASSET__C9UgF1Nc__"